import { Injectable } from '@angular/core';
import { ThemeService } from '@themes';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StateService, States } from '@state';

@Injectable()
export class PreregisterNavigationAccessService implements CanActivate {
    constructor(
        private stateService: StateService
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        boolean | Promise<boolean> | Observable<boolean> {
        return new Promise(async(resolve, reject) => {
            this.stateService.value(States.themeConfig).subscribe((themeConfig: any) => {
                if(!themeConfig) {
                    return false;
                }
                resolve(themeConfig.showPreRegister);
                return true;
            }, true).while.falsy();
        });
    }
}
